import type { AxiosResponse, InternalAxiosRequestConfig } from "./types";
import { ElMessage } from "element-plus";
import { objToFormData } from "@/utils/index";
import qs from "qs";
/**
 * 请求成功状态码
 */
const SUCCESS_CODE = 200;
/**
 * 是否根据headers->content-type自动转换数据格式
 */
const TRANSFORM_REQUEST_DATA = true;

/**
 * 请求拦截器
 * @param config
 */

const defaultRequestInterceptors = (config: InternalAxiosRequestConfig) => {
  if (config.method === "post" && config.headers["Content-Type"] === "application/x-www-form-urlencoded") {
    // 序列化data
    config.data = qs.stringify(config.data);
  } else if (TRANSFORM_REQUEST_DATA && config.method === "post" && config.headers["Content-Type"] === "multipart/form-data" && !(config.data instanceof FormData)) {
    // 将请求数据转换为FormData对象。
    config.data = objToFormData(config.data);
  }
  //  else if (config.method === "get" && config.params) {
  //   let url = config.url as string;
  //   url += "?";
  //   // 将参数拼接到请求url中
  //   const keys = Object.keys(config.params);
  //   for (const key of keys) {
  //     if (config.params[key] !== void 0 && config.params[key] !== null) {
  //       url += `${key}=${encodeURIComponent(config.params[key])}&`;
  //     }
  //   }
  //   url = url.substring(0, url.length - 1);
  //   config.params = {};
  //   config.url = url;
  // }
  return config;
};

/**
 * 响应拦截器
 * @param response
 */
const defaultResponseInterceptors = (response: AxiosResponse) => {
  if (response?.config?.responseType === "blob") {
    // 如果是文件流，直接过
    return response;
  } else if (response.data.code === SUCCESS_CODE) {
    return response.data;
  } else {
    ElMessage.error(response?.data?.msg);
  }
};
export { defaultResponseInterceptors, defaultRequestInterceptors };
